import { IEmployeeCheck } from "@zeal/common";
import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";

export const getPreviewChecks = (axios: IAxiosInstance) => {
  return async (requestBody: { checkIDs: string[] }) => {
    const response = await axios.noRetry.post<
      IApiResponse<IEmployeeCheck["preview"][]>
    >("/api/getBulkPreviewChecks", requestBody);

    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
